
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var ApiResources = require("assets/data/apiResources.json");


    var ContentCannedDefaultsModel = {};
    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentCannedDefaultsModel = BaseModel.extend({
            resource: ApiResources.AccountConfig.CannedMessagesDefaults,
            name: "ContentCannedDefaultsModel"
        });
    });

    return ContentCannedDefaultsModel;
});
